module.exports = __webpack_public_path__ + "static/media/do-it.ac67e3a1.png";